import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { Image } from 'react-bootstrap'
const NavigationBar = () => {
    return (

        <>

            <Navbar expand="lg" className="bg-black py-2 sticky-top">
                <Container>

                    <Nav
                        className="mx-auto my-2 my-lg-0"
                        style={{ maxHeight: '100px' }}
                        navbarScroll
                    >
                        <Navbar.Brand href="#hero" >
                            <Image src={"https://d2bxnt3cp18qf5.cloudfront.net/logo.webp"} width={"100%"} />
                        </Navbar.Brand>
                    </Nav>
                </Container>
            </Navbar>


        </>
    );
}

export default NavigationBar;